import { type Dispatch, type SetStateAction, type ReactNode, createContext, useContext, useState } from 'react';

/**
 * Types
 */
type ColorState = {
  primaryAccentColor?: string;
  secondaryAccentColor?: string;
};
type DispatchFunction = Dispatch<SetStateAction<ColorState>>;
type Props = {
  children: ReactNode;
};
type ProviderState = {
  colors: ColorState;
  setColors: DispatchFunction;
};

/**
 * Contexts
 */
export const ColorContext = createContext<ColorState>({
  primaryAccentColor: undefined,
  secondaryAccentColor: undefined
});
const ColorUpdateContext = createContext<DispatchFunction>(() => undefined);

/**
 * Provider
 */

export function ColorProvider({
  children
}: Props) {
  const [state, dispatch] = useState<ColorState>({
    primaryAccentColor: undefined,
    secondaryAccentColor: undefined
  });
  return <ColorContext.Provider value={state} data-sentry-element="ColorContext.Provider" data-sentry-component="ColorProvider" data-sentry-source-file="ColorProvider.tsx">
			<ColorUpdateContext.Provider value={dispatch} data-sentry-element="ColorUpdateContext.Provider" data-sentry-source-file="ColorProvider.tsx">{children}</ColorUpdateContext.Provider>
		</ColorContext.Provider>;
}

/**
 * Hook
 */
export function useColorProvider(): ProviderState {
  return {
    colors: useContext(ColorContext),
    setColors: useContext(ColorUpdateContext)
  };
}